<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <input type="text" #field [ngClass]="(readOnly ? 'form-control disabled' : 'form-control')"
        [id]="(id === null ? name : id)" [name]="name" [value]="value" [attr.maxlength]="maxSize" [disabled]="readOnly"
        (input)="changeValue($event)" [placeholder]="placeholder" (keyup)="pressKey($event)" />
</ng-template>
<ng-template #showSpan>
    <span type="text" #field [id]="(id === null ? name : id)">
        {{value}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
    <app-input-feedback [hidden]="!validMaxSize()" [feedbackMessage]="spanMaxSize"></app-input-feedback>
    <app-input-feedback [hidden]="!validMinSize()" [feedbackMessage]="spanMinSize"></app-input-feedback>
    <app-input-feedback [hidden]="!validAlphaNumeric()" [feedbackMessage]="spanAlphaNumeric"></app-input-feedback>
    <app-input-feedback [hidden]="!validMail()" [feedbackMessage]="spanEmail"></app-input-feedback>
</div>